import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './RatingPrompt.module.scss';

type RatingPromptProps = {
  textColor: string;
  promptText: string;
  scaleHint: string;
  compact?: boolean;
};

export const RatingPrompt: FC<RatingPromptProps> = ({
  textColor,
  promptText,
  scaleHint,
  compact,
}) => (
  <div
    className={classNames(classes.prompt, compact && classes.compact)}
    style={{ color: textColor }}
  >
    {promptText ? <p className={classes.line}>{promptText}</p> : null}
    {scaleHint ? <p className={classes.line}>{scaleHint}</p> : null}
  </div>
);
